import React from "react";
import "./App.css";
import AuthProvider from "./hooks/AuthProvider/AuthProvider";
import Footer from "./components/Footer/Footer";
import DynamicRoutes from "./route/DynamicRoutes";
import { RoutesProvider } from "./hooks/RoutesProvider/RoutesProvider";


function App() {
  return (
    <AuthProvider>
      <RoutesProvider>
        <div className="flex flex-col min-h-screen">
          <main className="flex-1">
            <DynamicRoutes />
          </main>
          <Footer />
        </div>
      </RoutesProvider>
    </AuthProvider>
  );
}

export default App;